//
// Module for the Tax Tables and Rates lump sum rates view
//
rs.module("system/configuration/taxtablesandrates/lumpsumrates",

    [ "controls/components/event-banner" ],

    function (eventBanner) {

        var _executeSelectionChanged;

        // Initialize the module
        function initialize(jsSelectors, grid, backendUrls, isStateLumpSum) {

            // Unpack js Selectors
            var criteria = $.js(jsSelectors.criteria);

            var gridAddButton = criteria.js(jsSelectors.gridAddButton);
            var hiddenStateLumpSumKey = criteria.js(jsSelectors.hiddenStateLumpSumKey, { required: false });
            var stateTaxRateInput = criteria.js(jsSelectors.stateTaxRateInput, { required: false });
            var stateTaxableMinAmountInput = criteria.js(jsSelectors.stateTaxableMinAmountInput, { required: false });
            var hiddenFederalLumpSumKey = criteria.js(jsSelectors.hiddenFederalLumpSumKey, { required: false });
            var federalMandatoryRateInput = criteria.js(jsSelectors.federalMandatoryRateInput, { required: false });
            var federalVoluntaryRateInput = criteria.js(jsSelectors.federalVoluntaryRateInput, { required: false });
            var federalTaxableMinimumAmountInput = criteria.js(jsSelectors.federalTaxableMinimumAmountInput, { required: false });
            var hiddenUpdateToken = criteria.js(jsSelectors.hiddenUpdateToken);
            var effectiveDateInput = criteria.js(jsSelectors.effectiveDateInput);
            var terminationDateInput = criteria.js(jsSelectors.terminationDateInput);

            // Handle grid add button click event
            gridAddButton.click(function () {
                clearCriteria();
                grid.selectedValues = null;
            });

            // On Grid selection change, load criteria with selected item
            grid.selectionChanged(function (values, rows) {

                // This handler fires when the grid is first rendered, but we don't want it to in our case
                // _executeStateSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                if (_executeSelectionChanged && values.length > 0) {

                    clearCriteria();

                    if (values.length > 0) {
                        loadLumpSum(values[0]);
                    }
                }
                _executeSelectionChanged = true;
            });

            // Load the selected Lump Sum Rate
            function loadLumpSum(selectedLumpSumKey) {
                $.getJSON(
                    backendUrls.getLumpSumRateAsync,
                    {
                        lumpSumKey: selectedLumpSumKey,
                        isStateLumpSum: isStateLumpSum
                    })
                    .done(function (data) {

                        if (isStateLumpSum) {
                            hiddenStateLumpSumKey.val(data.lumpSumKey);
                            stateTaxRateInput.val(data.taxRate);
                            stateTaxableMinAmountInput.val(data.taxableMinimumAmount);
                        }
                        else {
                            hiddenFederalLumpSumKey.val(data.lumpSumKey);
                            federalMandatoryRateInput.val(data.mandatoryTaxRate);
                            federalVoluntaryRateInput.val(data.voluntaryRate);
                            federalTaxableMinimumAmountInput.val(data.taxableMinimumAmount);
                        }

                        hiddenUpdateToken.val(data.updateToken);
                        effectiveDateInput.val(data.effectiveDate);
                        terminationDateInput.val(data.terminationDate);

                    });
            }

            // Clear lump sum rate criteria
            function clearCriteria() {

                eventBanner.removeAllMessages();

                if (isStateLumpSum) {
                    hiddenStateLumpSumKey.val(-1);
                    [
                        stateTaxRateInput,
                        stateTaxableMinAmountInput,
                        hiddenUpdateToken,
                        effectiveDateInput,
                        terminationDateInput
                    ].forEach((input) => input.clearErrors().val(''));
                }
                else {
                    hiddenFederalLumpSumKey.val(-1);
                    [
                        federalMandatoryRateInput,
                        federalVoluntaryRateInput,
                        federalTaxableMinimumAmountInput,
                        hiddenUpdateToken,
                        effectiveDateInput,
                        terminationDateInput
                    ].forEach((input) => input.clearErrors().val(''));
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);